import { createApi } from '@reduxjs/toolkit/query/react';
import { createApiConfig } from '../../../createApiConfig';

export const lMTelegramApi = createApi({
  reducerPath: 'lMTelegramApi',
  ...createApiConfig(process.env.REACT_APP_API_BASE_URL),
  tagTypes: ['TelegramLinks'],
  endpoints: (builder) => ({
    getTelegramLinks: builder.query({
      query: (params) => ({
        url: `/links/telegram/`,
        params,
      }),
      providesTags: ['TelegramLinks'],
    }),

    getAggregateByCampaign: builder.query({
      query: (params) => ({
        url: `/links/telegram/aggregate-by-campaign/`,
        params,
      }),
      providesTags: ['TelegramLinks'],
    }),

    createTelegram: builder.mutation({
      query: (body) => ({
        url: '/links/telegram/',
        method: 'POST',
        body,
      }),
      invalidatesTags: ['TelegramLinks'],
    }),
    markTelegram: builder.mutation({
      query: (body) => ({
        url: `/links/telegram/mark/`,
        method: 'POST',
        body,
      }),
      invalidatesTags: ['TelegramLinks'],
    }),

    getTelegramById: builder.query({
      query: (id) => ({
        url: `/links/telegram/${id}`,
        method: 'GET',
      }),
      providesTags: (result, error, id) => [{ type: 'TelegramLinks', id }],
    }),

    updateTelegramById: builder.mutation({
      query: ({ id, body }) => ({
        url: `/links/telegram/${id}/`,
        method: 'PUT',
        body,
      }),
      invalidatesTags: ['TelegramLinks'],
    }),

    deleteTelegramById: builder.mutation({
      query: (id) => ({
        url: `/links/telegram/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: (result, error, id) => [{ type: 'TelegramLinks', id }],
    }),
  }),
});

export const {
  useGetTelegramLinksQuery,
  useGetAggregateByCampaignQuery,
  useCreateTelegramMutation,
  useMarkTelegramMutation,
  useGetTelegramByIdQuery,
  useUpdateTelegramByIdMutation,
  useDeleteTelegramByIdMutation,
} = lMTelegramApi;
